import { c as _c } from "react/compiler-runtime";
import Typography from '@mui/material/Typography';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { formatDateISO } from '@shared/utils';
import dayjs from 'dayjs';
export const DatePicker = t0 => {
  const $ = _c(37);
  let dateFormatter;
  let error;
  let hiddenLabel;
  let label;
  let onChange;
  let rest;
  let size;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      label,
      hiddenLabel,
      disablePast: t1,
      error,
      dateFormatter,
      onChange,
      size,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = dateFormatter;
    $[2] = error;
    $[3] = hiddenLabel;
    $[4] = label;
    $[5] = onChange;
    $[6] = rest;
    $[7] = size;
    $[8] = t1;
    $[9] = value;
  } else {
    dateFormatter = $[1];
    error = $[2];
    hiddenLabel = $[3];
    label = $[4];
    onChange = $[5];
    rest = $[6];
    size = $[7];
    t1 = $[8];
    value = $[9];
  }
  const disablePast = t1 === undefined ? false : t1;
  let t2;
  if ($[10] !== value) {
    t2 = value ? dayjs(value).startOf("day") : null;
    $[10] = value;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const dateJsValue = t2;
  const t3 = !hiddenLabel ? label : "";
  const t4 = !!error;
  let t5;
  if ($[12] !== error) {
    t5 = error?.message ? {
      helperText: <Typography minHeight={20}>{error.message}</Typography>
    } : {};
    $[12] = error;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== dateFormatter || $[15] !== value) {
    t6 = dateFormatter ? dateFormatter(value) : formatDateISO(value);
    $[14] = dateFormatter;
    $[15] = value;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = {
      value: t6,
      readOnly: true
    };
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = error?.message ? "block" : "none";
  let t9;
  if ($[19] !== t8) {
    t9 = {
      "& .MuiFormHelperText-root": {
        display: t8,
        m: 0
      }
    };
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== size || $[22] !== t4 || $[23] !== t5 || $[24] !== t7 || $[25] !== t9) {
    t10 = {
      fullWidth: true,
      size,
      error: t4,
      ...t5,
      placeholder: "DD MMM YYYY",
      InputProps: t7,
      sx: t9
    };
    $[21] = size;
    $[22] = t4;
    $[23] = t5;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      actions: ["clear", "today"]
    };
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10) {
    t12 = {
      textField: t10,
      actionBar: t11
    };
    $[28] = t10;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== dateJsValue || $[31] !== disablePast || $[32] !== onChange || $[33] !== rest || $[34] !== t12 || $[35] !== t3) {
    t13 = <LocalizationProvider dateAdapter={AdapterDayjs}><MuiDatePicker label={t3} value={dateJsValue} onChange={onChange} disablePast={disablePast} {...rest} slotProps={t12} /></LocalizationProvider>;
    $[30] = dateJsValue;
    $[31] = disablePast;
    $[32] = onChange;
    $[33] = rest;
    $[34] = t12;
    $[35] = t3;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
};